import { useTranslate } from '@festina-life/ui/hooks'

import { useResolvePartnershipIdForCommandData } from '../../hooks/useResolvePartnershipIdForCommandData'
import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../commandActions/types'
import { EndPartnershipCommandDataForm } from './EndPartnershipCommandDataForm'

export function EndRelationshipCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()

  const partnershipId = useResolvePartnershipIdForCommandData(props)

  const actions = useHook('mutators.crm.useEndRelationshipActions')({
    personId: ownerId,
    tenantId,
    partnershipId,
    ...props,
  })
  const submit = useVariantAction({
    ...props,
    actions,
  })

  return (
    <CommandModalButton
      actionId="legalEntity.EndPartnershipCommandData"
      title={translate('divorceButton.title')}
      commandDataForm={EndPartnershipCommandDataForm}
      submit={submit}
      {...props}
    />
  )
}
